<template>
  <el-dropdown trigger="click" @command="handleCommand">
    <button class="language-switch" type="button" :aria-label="t('language.label')">
      <span>{{ currentLabel }}</span>
      <el-icon class="language-switch__icon"><caret-bottom /></el-icon>
    </button>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item
          v-for="item in localeOptions"
          :key="item.value"
          :command="item.value"
          :disabled="item.value === currentLocale"
        >
          {{ item.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { getCurrentLocale, setLocale, type AppLocale } from '@/locales'

const { t, locale } = useI18n()
const route = useRoute()

const localeOptions = computed(() => [
  { value: 'zh-CN' as AppLocale, label: t('language.zhCN') },
  { value: 'en-US' as AppLocale, label: t('language.enUS') },
])

const currentLocale = computed(() => getCurrentLocale())
const currentLabel = computed(() => localeOptions.value.find(item => item.value === currentLocale.value)?.label)

function handleCommand(value: AppLocale) {
  locale.value = setLocale(value)
  if (!['/login', '/register'].includes(route.path)) {
    window.location.reload()
  }
}
</script>

<style lang="scss" scoped>
.language-switch {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 10px;
  color: inherit;
  font-size: 14px;
  line-height: 1;
  background: transparent;
  border: 1px solid currentColor;
  border-radius: 16px;
  cursor: pointer;
}

.language-switch__icon {
  font-size: 12px;
}
</style>
